import React, { useState } from 'react'
import Navbar from '../Navbar/Navbar'
import Footer from '../footer/Footer'
import { GrMail } from 'react-icons/gr'
import { IoIosCall } from 'react-icons/io'
import { MdLocationPin } from 'react-icons/md'
import Location from '../../Assets/location-dot-solid.svg'
import phone from '../../Assets/phone-solid.svg'
import "./contact.css";
import Branch from '../search branch/Branch'
import { Helmet } from "react-helmet";
import LogoContact from '../logoContact/logoContact'
import Newnavbar from '../newNavbar/Newnavbar'
import { FaWhatsapp } from "react-icons/fa";
import Newenqire from '../Enquire Form/Newenqire'

import Breadcrumbs from '../../seo/Breadcrumbs';
export default function Contact() {

    const [name, setName] = useState('')
    const [mail, setMail] = useState('')
    const [number, setNumber] = useState('')
    const [address, setAddress] = useState('')
    const [pincode, setPincode] = useState()
    const [message, setMessage] = useState('')
    const [selectedCenterValue, setSelectedCenterValue] = useState();
    const [selectedValue, setSelectedValue] = useState();
    const [selectSchool, setSelectSchool] = useState('');
    const [selectCollege, setSelectCollege] = useState('');
    const [selectCbse, setSelectCbse] = useState();
    const [selectIcse, setSelectIcse] = useState();
    const [selectSsc, setSelectssc] = useState()
    const [agree, setAgree] = useState(false);


    function handleSelectChange(event) {
        setSelectedValue(event.target.value);
        if (event.target.value == 'College' || event.target.value == 'Performance Booster' || event.target.value == 'Pre-school' || event.target.value == 'saab') {
            setSelectSchool('')
        }
    }

    function handleCenter(event) {
        setSelectedCenterValue(event.target.value)
    }

    function handleSchoolBoard(event) {
        setSelectSchool(event.target.value)
    }

    function handleCollegeBorad(event) {
        setSelectCollege(event.target.value)
    }

    function handleCbseBorad(event) {
        setSelectCbse(event.target.value)
    }

    function handleIcseBorad(event) {
        setSelectIcse(event.target.value)
    }

    function handlesscBorad(event) {
        setSelectssc(event.target.value)
    }

    function schoolchange() {
        if (name && number && mail && selectedCenterValue && selectedValue) {
            if (selectSchool == 'CBSE' && selectCbse) {
                const mailtoLink = `mailto:enquiry@nayakstutorials.com?subject=Student requested a callback&body=Name: ${name}%0A
        Phone Number: ${number}%0A
        Email: ${mail}%0A
        Number: ${number}%0A
        Message: ${message}%0A
        Center:${selectedCenterValue}%0A
        Offerings: ${selectedValue}%0A
        School: ${selectSchool}%0A
        Cbse: ${selectCbse}%0A`;


                window.location.href = mailtoLink;
            } else if (selectSchool == 'ICSE' && selectIcse) {
                const mailtoLink = `mailto:enquiry@nayakstutorials.com?subject=Student requested a callback&body=Name: ${name}%0A
        Phone Number: ${number}%0A
        Email: ${mail}%0A
        Number: ${number}%0A
        Message: ${message}%0A
        Center:${selectedCenterValue}%0A
        Offerings: ${selectedValue}%0A
        School: ${selectSchool}%0A
        Icse: ${selectIcse}%0A`;


                window.location.href = mailtoLink;
            } else if (selectSchool == 'SSC' && selectSsc) {
                const mailtoLink = `mailto:enquiry@nayakstutorials.com?subject=Student requested a callback&body=Name: ${name}%0A
        Phone Number: ${number}%0A
        Email: ${mail}%0A
        Number: ${number}%0A
        Message: ${message}%0A
        Center:${selectedCenterValue}%0A
        Offerings: ${selectedValue}%0A
        School: ${selectSchool}%0A
        Ssc: ${selectSsc}%0A`;
                window.location.href = mailtoLink;
            } else if (selectSchool == 'IGCSE') {
                const mailtoLink = `mailto:enquiry@nayakstutorials.com?subject=Student requested a callback&body=Name: ${name}%0A
        Phone Number: ${number}%0A
        Email: ${mail}%0A
        Number: ${number}%0A
        Message: ${message}%0A
        Center:${selectedCenterValue}%0A
        Offerings: ${selectedValue}%0A
        School: ${selectSchool}%0A`;
                window.location.href = mailtoLink;
            } else if (selectedValue == 'Performance Booster') {
                const mailtoLink = `mailto:enquiry@nayakstutorials.com?subject=Student requested a callback&body=Name: ${name}%0A
        Phone Number: ${number}%0A
        Email: ${mail}%0A
        Number: ${number}%0A
        Message: ${message}%0A
        Center:${selectedCenterValue}%0A
        Offerings: ${selectedValue}%0A`;
                window.location.href = mailtoLink;
            }
            else if (selectedValue == 'Pre-school') {
                const mailtoLink = `mailto:enquiry@nayakstutorials.com?subject=Student requested a callback&body=Name: ${name}%0A
        Phone Number: ${number}%0A
        Email: ${mail}%0A
        Number: ${number}%0A
        Message: ${message}%0A
        Center:${selectedCenterValue}%0A
        Offerings: ${selectedValue}%0A`;
                window.location.href = mailtoLink;
            } else if (selectCollege) {
                const mailtoLink = `mailto:enquiry@nayakstutorials.com?subject=Student requested a callback&body=Name: ${name}%0A
        Phone Number: ${number}%0A
        Email: ${mail}%0A
        Number: ${number}%0A
        Message: ${message}%0A
        Center:${selectedCenterValue}%0A
        Offerings: ${selectedValue}%0A
        College: ${selectCollege}%0A`;
                window.location.href = mailtoLink;
            } else {
                alert("Please fill in all required fields before sending the email.");
            }
        } else {
            alert("Please fill in all required fields before sending the email.");
        }
    }


    const body = {
        name: name,
        number: number,
        mail: mail,
        address: address,
        pincode: pincode,
        message: message,
        selectedValue: selectedValue,
        selectCollege: selectCollege,
        selectSchool: selectSchool,
        selectCbse: selectCbse,
        selectIcse: selectIcse
    }

    const mailtoBody = encodeURIComponent(JSON.stringify(body));

    const handleEmailSubmission = (e) => {
        if (name && number && mail) {
            const mailtoLink = `mailto:enquiry@nayakstutorials.com?subject=Student requested a callback&body=Name: ${name}%0A
        Phone Number: ${number}%0A
        Email: ${mail}%0A
        Number: ${number}%0A
        Address: ${address}%0A
        Pincode: ${pincode}%0A
        Message: ${message}%0A
        Offerings: ${selectedValue}%0A
        College: ${selectCollege}%0A
        School: ${selectSchool}%0A
        Cbse: ${selectCbse}%0A
        Icse: ${selectIcse}%0A`;

            window.location.href = mailtoLink; // This will open the email client with the mailtoLink.
        } else {
            alert("Please fill in all required fields before sending the email.");
        }
    };

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Contact Nayak's Tutorials Main Branch in Thane</title>
                <meta name="title" content="Contact Us: Get in Touch with Nayak's Tutorials Thane" />
                <meta name="description" content="Get in touch with Nayak's Tutorials' main branch in Thane. Find our address, phone numbers, and location map. We're here to answer your questions!" />

                <link rel="canonical" href="https://nayakstutorials.com/contact/" />

</Helmet>
            {/* <Navbar /> */}


            <div className="wpfloat">
                <LogoContact />
                <Newnavbar />
            <Breadcrumbs route="/contact" />
                <div className="contactBackground">
                    <div className='mainPrivacy2'>


                        <h2 className="contactush2" >contact <span>us</span></h2>
                        <div className="contactUsDiv">
                            <div className="row1"  >
                                <div className="rownewcontact ">
                                    <a className='contactAnchor' target='_blank' style={{ textDecoration: 'none', color: 'white' }} > <span style={{ display: 'flex', gap: '10px' }}><img src={Location} style={{ width: '15px', marginTop: '2px', color: 'white', fontWeight: '500' }} /><p style={{ marginBottom: '0px', fontWeight: '500', fontSize: '17px', color: 'black' }} >209, Vardhaman Industrial Complex, Gokul Nagar,<br /> Old Agra Road, Thane (West) 400601, Maharashtra, India</p></span></a>
                                    <a className='contactAnchor' target='_blank' href="mailto: info@nayakstutorials.com" style={{ textDecoration: 'none', color: 'white' }}><span style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '8px', marginBottom: '8px' }}><GrMail style={{ fontSize: '18px', color: 'black' }} /><p style={{ marginBottom: '0px', fontWeight: '500', fontSize: '17px', color: 'black' }}>info@nayakstutorials.com</p></span></a>
                                    <span style={{ display: 'flex', alignItems: 'center', gap: '10px' }}><img src={phone} style={{ width: '15px', color: 'white' }} /><p style={{ color: 'red', marginBottom: '0px', fontSize: '17px' }}> <a href='tel: 22 21723434' className="aboutUsNo contactAnchor" style={{ textDecoration: 'none', color: 'red', fontWeight: '500', color: 'black' }}>+91 2221723434 </a>| <a target='_blank' style={{ textDecoration: 'none', color: 'red', fontWeight: '500', color: 'black' }} className="aboutUsNo contactAnchor" href='tel: 77100 10044'>+91 7710010044</a></p></span>
                                </div>

                                {/* <div className="googleMap mt-4">
                                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3767.704144621394!2d72.97558547520869!3d19.20812028202389!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b944f8bc26c5%3A0x5a2f1f2e1b1a36a9!2sNayak%E2%80%99s%20Tutorials%7C%20Coaching%20Classes%20in%20Vardhaman%20%2CThane%20(W)%7C%20CBSE%7C%20ICSE%7C%20IGCSE%7C%20SSC%20Board%20class%20viii%20ix%20x%20NEET%20JEE!5e0!3m2!1sen!2sin!4v1739957535514!5m2!1sen!2sin" width="460" height="380" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                </div> */}
                                <div className='contactForm'>
                                    <form className='EnqForm'>
                                        <div class="mb-3">
                                            <input value={name} onChange={(e) => setName(e.target.value)} placeholder='Full Name' type="text" class="form-control" id="recipient-name" />
                                        </div>
                                        <div className='row mb-1'>
                                            <div className='col-md-4 inputmargin'><input value={mail} onChange={(e) => setMail(e.target.value)} placeholder='Email (@example.com)' type="text" class="form-control" id="recipient-name" /></div>
                                            <div className='col-md-4 mb-3'><input value={number} maxLength={10} onChange={(e) => setNumber(e.target.value)} placeholder='Contact Number' type="text" class="form-control" id="recipient-name" /></div>
                                            <div className='col-md-4 mb-3'>
                                                <select placeholder='Our Centers' className='FormSelect' name="cars" id="cars" value={selectedCenterValue} onChange={handleCenter}>
                                                    <option value="Our Centers">Our Centers</option>
                                                    <option value="Thane Vardhaman">Thane Vardhaman</option>
                                                    <option value="Thane Naupada">Thane Naupada</option>
                                                    <option value="Thane Vartak Nagar">Thane Vartak Nagar</option>
                                                    <option value="Thane Vasant Vihar">Thane Vasant Vihar</option>
                                                    <option value="Thane Manpada">Thane Manpada</option>
                                                    <option value="Thane Hiranandani">Thane Hiranandani</option>
                                                    <option value="Thane Anand Nagar">Thane Anand Nagar</option>
                                                    <option value="Kalwa">Kalwa</option>
                                                    <option value="Mulund Veena Nagar">Mulund Veena Nagar</option>
                                                    <option value="Mulund East">Mulund East</option>
                                                    <option value="Mira Road Sec.5">Mira Road Sec.5</option>
                                                    <option value="Mira Road Jangid">Mira Road Jangid</option>
                                                    <option value="Satara">Satara</option>
                                                    <option value="Bandra">Bandra</option>
                                                    <option value="EDUACE GROUP TUITIONS (Mulund East)">EDUACE GROUP TUITIONS (Mulund East)</option>
                                                    <option value="EDUACE GROUP TUITIONS (Ghatkopar East)">EDUACE GROUP TUITIONS (Ghatkopar East)</option>
                                                    <option value="EDUACE GROUP TUITIONS (Mulund West)">EDUACE GROUP TUITIONS (Mulund West)</option>
                                                </select>
                                            </div>
                                        </div>
                               
                                        <div className='row mb-1'>
                                            <div className='col-md-4 mb-3'>
                                                <select placeholder='Our Offerings' className='FormSelect' name="cars" id="cars" value={selectedValue}
                                                    onChange={handleSelectChange}>
                                                    <option value="saab">Our Offerings</option>
                                                    <option value="School">School</option>
                                                    <option value="College">College</option>
                                                    <option value="Performance Booster">Performance Booster</option>
                                                    <option value="Pre-school">Pre-school</option>
                                                </select>
                                            </div>
                                            <div className='col-md-4 mb-3'>


                                                {selectedValue === 'School' && (
                                                    <select
                                                        placeholder='School Board'
                                                        className='FormSelect'
                                                        name="schoolBoard"
                                                        value={selectSchool}
                                                        onChange={handleSchoolBoard}
                                                    >
                                                        <option value="School Board"> Select School Board</option>
                                                        <option value="CBSE">CBSE</option>
                                                        <option value="ICSE">ICSE</option>
                                                        <option value="IGCSE">IGCSE</option>
                                                        <option value="SSC">SSC</option>
                                                    </select>
                                                )}

                                                {selectedValue === 'College' && (
                                                    <select
                                                        placeholder='College'
                                                        className='FormSelect'
                                                        name="college"
                                                        value={selectCollege}
                                                        onChange={handleCollegeBorad}
                                                    >
                                                        <option value="College"> Select College</option>
                                                        <option value="11th and 12th">11th and 12th</option>
                                                        <option value="CA & CS">CA & CS</option>
                                                        <option value="Engineering and medical">Pre Engineering</option>
                                                        <option value="Engineering and medical">Pre Medi</option>
                                                        <option value="TY Bcom">TY Bcom</option>
                                                    </select>
                                                )}


                                            </div>
                                            <div className='col-md-4'>
                                                {/* <input placeholder='Please Select Standard' type="text" class="form-control" id="recipient-name" /> */}
                                                {selectSchool === 'CBSE' && (
                                                    <select
                                                        placeholder='Cbse'
                                                        className='FormSelect'
                                                        name="schoolBoard"
                                                        value={selectCbse}
                                                        onChange={handleCbseBorad}
                                                    >
                                                        <option value="School Board">Select STD</option>
                                                        <option value="CBSE 8TH">CBSE 8TH</option>
                                                        <option value="CBSE 9TH">CBSE 9TH</option>
                                                        <option value="CBSE 10TH">CBSE 10TH</option>
                                                    </select>
                                                )}

                                                {selectSchool === 'ICSE' && (
                                                    <select
                                                        placeholder='Cbse'
                                                        className='FormSelect'
                                                        name="schoolBoard"
                                                        value={selectIcse}
                                                        onChange={handleIcseBorad}
                                                    >
                                                        <option value="ICSE">Select STD</option>
                                                        <option value="ICSE 8TH">ICSE 8TH</option>
                                                        <option value="ICSE 9TH">ICSE 9TH</option>
                                                        <option value="ICSE 10TH">ICSE 10TH</option>
                                                    </select>
                                                )}

                                                {selectSchool === 'SSC' ? (
                                                    <select
                                                        placeholder='Cbse'
                                                        className='FormSelect'
                                                        name="schoolBoard"
                                                        value={selectSsc}
                                                        onChange={handlesscBorad}
                                                    >
                                                        <option value="SSC">Select STD</option>
                                                        <option value="SSC 8TH">SSC 8TH</option>
                                                        <option value="SSC 9TH">SSC 9TH</option>
                                                        <option value="SSC 10TH">SSC 10TH</option>
                                                    </select>
                                                ) : null}


                                            </div>
                                        </div>
                                        <div class="mb-3" style={{ marginBottom: '10px' }}>
                                            <textarea rows="4" cols="50" value={message} onChange={(e) => setMessage(e.target.value)} placeholder='Enter Your Message (Optional)' class="form-control" id="message-text"></textarea>
                                        </div>
                                        <div className="mt-2">
                                            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '1px' }}>

                                                {/* Checkbox */}
                                                <input
                                                    type="checkbox"
                                                    id="agreeCheck"
                                                    checked={agree}
                                                    onChange={(e) => setAgree(e.target.checked)}
                                                    style={{ marginTop: 3, accentColor: '#D00000' }}

                                                />

                                                {/* Text with links */}
                                                <label htmlFor="agreeCheck" style={{ fontSize: 13, color: '#000' }}>
                                                    I hereby authorise to receive notifications on SMS/Message. By submitting your personal information, you agree to our
                                                    <a href="/privacy-policy/" target="_blank" style={{ color: '#D00000', textDecoration: 'none', marginLeft: 4, fontWeight: '800' }}>
                                                        Privacy Policy
                                                    </a>
                                                    {' '}and{' '}
                                                    <a href="/terms-and-conditions/" target="_blank" style={{ color: '#D00000', textDecoration: 'none', fontWeight: '800' }}>
                                                        Terms & Conditions
                                                    </a>.
                                                </label>

                                            </div>
                                        </div>

                                        <div className='modalBtn'>
                                            <button type="button" className="btn btn-secondary FormSubmit" data-bs-dismiss="modal" onClick={agree ? schoolchange : null}
                                                disabled={!agree}
                                            >Submit</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='contactBranch' >

                    <Branch />
                </div>
                <Footer />

                <a href="https://wa.me/+917710010044" target="_blank"><div className="wpicon"><FaWhatsapp id='faWp' size={50} color='white' /></div></a>

                {/* <div className='newenquirediv'><Newenqire /></div> */}

            </div>
        </>
    )
}
